import React from 'react';
import { Grid } from '@material-ui/core';

import RecipeCardLoading from 'components/recipes/cards/RecipeCardLoading';

const RecipesListLoading = ({ count = 1 }) => {
  const items = Array.from({ length: count });

  return (
    <Grid container direction="column" spacing={3}>
      {items.map((_, index) => {
        return (
          <Grid item key={index}>
            <RecipeCardLoading></RecipeCardLoading>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RecipesListLoading;
